import { useState } from "react";
import StatsComponent from "../common/StatsComponent";
import BarMixedCharts from "../common/BarChart";
import Loader from "../../../../presentationals/Loader/Loader.component";
import { MenuItem, Pagination, Select, Stack } from "@mui/material";
// const busessInsightsFunnel = [
//   "12.8% customers drop after Aadhar",
//   "Approx ₹2.4L API cost wasted",
//   "Improving Aadhar Success by 5% can save ₹45,000/month",
// ];
export default function Aadhaar({
  isSummaryLoading,
  isTableLoading,
  statsOption,
  chartData,
  tableData,
  totalCount,
  setNoOfRows,
  pageNumber,
  setPageNumber,
  noOfRows,
}) {
  const [FirstMixedchartFilter, setFirstMixedchartFilter] = useState({
    type: "monthly",
    apiType: "",
    apiList: [],
  });
  const [SecondMixedchartFilter, setSecondMixedchartFilter] = useState({
    type: "monthly",
    apiType: "",
    apiList: [],
  });
  //   const [tableData, setTableData] = useState([]);
  //   const [statsOption, setStatsOption] = useState({
  //     "API Name": `${heading} API`,
  //     Vendor: "UIDAI / Partner",
  //     "SLA Breaches": "3%",
  //     "Total Hits": "1,20,000",
  //     "Impacted Loans": "9,600",
  //     "Total Cost": "₹18,00,000",
  //     "Cost Per Hits": "₹15",
  //     "Success Rate": "92%",
  //     "Failure Rate": "8%",
  //   });
  //   const [chartData, setchartData] = useState([]);

  return (
    <>
      {isSummaryLoading ? (
        <Loader />
      ) : (
        <div style={{ margin: window.innerWidth > 1800 ? "0 50px" : "" }}>
          <div style={{ marginTop: window.innerWidth > 1800 ? "57px" : "" }}>
            <StatsComponent Data={statsOption} />
          </div>

          <div
            className="row"
            style={{ marginTop: window.innerWidth > 1800 ? "57px" : "10px" }}
          >
            {/* <div className="col-lg-4 col-xs-12">
                    <div style={{ marginTop: '10px' }}>
                        <FunnelComponent 
                        heading={"Aadhaar API Impact on Loan Funnel"}
                        rightcardsTopHeaderLeft={"Drop-off Aadhar"}
                        dropOffRate={"12.8%"}
                        dropOffText={"(₹2,44,000 Wasted Cost)"}
                        businessInsights={busessInsightsFunnel} 
                        tbaleData={[]}
                        />
                    </div>
                </div> */}
            <div className="col-lg-6 col-xs-12">
              <div style={{ marginTop: "10px" }}>
                <BarMixedCharts
                  showFilters={false}
                  chartFilterValues={FirstMixedchartFilter}
                  setFilters={setFirstMixedchartFilter}
                  heading={"Success vs Failure Trend"}
                  AreaData={chartData}
                  xDataKeyName={"date"}
                   BarDataKeyName={"successRate"}
                  LineDataKeyName={"failureRate"}
                  colorType={"purpleishRed"}
                  LegendRight={"Failed Hits"}
                  LegendLeft={"Success Hits"}
                />
              </div>
            </div>
            <div className="col-lg-6 col-xs-12">
              <div style={{ marginTop: "10px" }}>
                <BarMixedCharts
                  showFilters={false}
                  chartFilterValues={SecondMixedchartFilter}
                  setFilters={setSecondMixedchartFilter}
                  heading={"Daily API Hits vs Cost"}
                  AreaData={chartData}
                  xDataKeyName={"date"}
                  BarDataKeyName={"totalCost"}
                  LineDataKeyName={"totalHits"}
                  colorType={"purpleishBlue"}
                  LegendRight={"Total API Hits"}
                  LegendLeft={"Total API Cost"}
                />
              </div>
            </div>
          </div>

          {isTableLoading ? (
            <Loader />
          ) : (
            <>
              <div
                className="row"
                style={{ marginTop: window.innerWidth > 1800 ? "57px" : "" }}
              >
                <div className="col-xs-12">
                  <div
                    className="customDash-table"
                    style={{ marginTop: "20px" }}
                  >
                    <div>
                      <h5>User Wise Detailed Table</h5>
                    </div>
                    <div className="main-customized-table">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Loan Id</th>
                            <th>Users</th>
                            <th>Hits</th>
                            <th>Success</th>
                            <th>Failed</th>
                            <th>Cost</th>
                            <th>Loan Status</th>
                            {/* <th>Form Status</th>
                        <th>Drop Off Stage</th> */}
                            {/* <th>Error Codes</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {tableData?.length > 0 ? (
                            tableData?.map((val, id) => {
                              return (
                                <tr key={id}>
                                  <td>{val?.applicationId || "N/A"}</td>
                                  <td>{val?.userName || "N/A"}</td>
                                  <td>{val?.totalHits ?? 0}</td>
                                  <td>{val?.successCount ?? 0}</td>
                                  <td>{val?.failureCount ?? 0}</td>
                                  <td>{val?.costing?.toFixed(2) ?? 0}</td>
                                  <td>{val?.loanStatus || "N/A"}</td>
                                  {/* <td>{val?.formStatus || "N/A"}</td>
                              <td>{val?.dropStage || "N/A"}</td> */}
                                  {/* <th>Error Codes</th> */}
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              {" "}
                              <td colSpan={10} style={{ textAlign: "center" }}>
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                {totalCount > 0 && (
                  <Stack
                    direction="row"
                    justifyContent="end"
                    alignItems="center"
                    sx={{ mt: 2 }}
                  >
                    <Pagination
                      count={Math.ceil(totalCount / noOfRows)}
                      page={pageNumber}
                      onChange={(e, value) => setPageNumber(value)}
                      // color="#43a4c7"
                      // shape="rounded"
                      sx={{
                        "& .MuiPaginationItem-root": {
                          color: "#43a4c7",
                          fontSize: window.innerWidth >= 1800 ? "20px" : "14px",
                          minWidth: window.innerWidth >= 1800 ? "40px" : "32px",
                          height: window.innerWidth >= 1800 ? "40px" : "32px",
                        },
                        "& .MuiPaginationItem-root.Mui-selected": {
                          backgroundColor: "#43a4c7",
                          color: "#fff",
                        },
                      }}
                    />
                  </Stack>
                )}
                </div>

              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}
